import axios from "axios";
import toast from "react-hot-toast";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const ASSIGN_PERMISSION_REQUEST = "ASSIGN_PERMISSION_REQUEST";
export const ASSIGN_PERMISSION_SUCCESS = "ASSIGN_PERMISSION_SUCCESS";
export const ASSIGN_PERMISSION_FAILURE = "ASSIGN_PERMISSION_FAILURE";

export const FETCH_ROLE_PERMISSIONS_REQUEST = "FETCH_ROLE_PERMISSIONS_REQUEST";
export const FETCH_ROLE_PERMISSIONS_SUCCESS = "FETCH_ROLE_PERMISSIONS_SUCCESS";
export const FETCH_ROLE_PERMISSIONS_FAILURE = "FETCH_ROLE_PERMISSIONS_FAILURE";

export const assignRolePermissions = (data) => async (dispatch) => {
  dispatch({ type: ASSIGN_PERMISSION_REQUEST });
  const token = localStorage.getItem("token");

  try {
    const response = await axios.post(
      `${BASE_URL}/v1/api/assignRolePermissions`,
      data,
      {
        headers: { authorization: token },
      },
    );

    if (response.data.meta.status) {
      dispatch({ type: ASSIGN_PERMISSION_SUCCESS });
      toast.success(
        response.data.meta.message || "Permissions assigned successfully",
      );
      return response.data;
    } else {
      dispatch({ type: ASSIGN_PERMISSION_FAILURE });
      throw new Error(response.data.meta.message);
    }
  } catch (error) {
    dispatch({ type: ASSIGN_PERMISSION_FAILURE });
    toast.error(
      error.response?.data?.meta?.message || "Failed to assign permissions",
    );
    throw error;
  }
};

export const fetchRolePermissions = () => async (dispatch) => {
  dispatch({ type: FETCH_ROLE_PERMISSIONS_REQUEST });
  const token = localStorage.getItem("token");

  try {
    const response = await axios.get(`${BASE_URL}/v1/api/getRolePermissions`, {
      headers: { authorization: token },
    });

    if (response.data.meta.status) {
      dispatch({
        type: FETCH_ROLE_PERMISSIONS_SUCCESS,
        payload: response.data.data,
      });
      return response.data;
    } else {
      dispatch({ type: FETCH_ROLE_PERMISSIONS_FAILURE });
      throw new Error(response.data.meta.message);
    }
  } catch (error) {
    dispatch({ type: FETCH_ROLE_PERMISSIONS_FAILURE });
    toast.error(
      error.response?.data?.meta?.message || "Failed to fetch role permissions",
    );
    throw error;
  }
};
